import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: 'column',
    backgroundColor: theme.palette.common.white,
    height: "100%",
  },
}));
